import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sd-dropdown-menu',
  standalone: true,
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuComponent {}
